import { render, staticRenderFns } from "./AssignSound.vue?vue&type=template&id=17d7d815&scoped=true"
import script from "./AssignSound.vue?vue&type=script&lang=ts"
export * from "./AssignSound.vue?vue&type=script&lang=ts"
import style0 from "./AssignSound.vue?vue&type=style&index=0&id=17d7d815&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d7d815",
  null
  
)

export default component.exports